let app = {};

app.VERSION = "1.3.0";
app.BUILDNUMBER = "30";

module.exports = app;
